<template>
  <div class="faq-page">
    <!-- Hero section -->
    <section class="faq-hero bg-primary text-white py-5 mb-4">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <h1 class="display-4 fw-bold mb-4">Domande Frequenti</h1>
            <p class="lead mb-4">
              Trova rapidamente le risposte alle tue domande sul nostro software di gestione integrata
              per auto e immobili nel FVG.
            </p>
            <!-- Barra di ricerca -->
            <div class="search-box bg-white rounded p-2 d-flex align-items-center">
              <i class="bi bi-search text-muted ms-2"></i>
              <input
                type="text"
                class="form-control border-0"
                placeholder="Cerca nelle FAQ..."
                v-model="searchQuery"
                @input="filterFAQs"
              >
            </div>
          </div>
          <div class="col-lg-4 text-center d-none d-lg-block">
            <i class="bi bi-question-circle display-1 opacity-50"></i>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Component -->
    <FAQ ref="faqComponent" />

    <!-- Call to Action -->
    <section class="cta py-5 bg-light">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-lg-6">
            <h3 class="mb-4">Non hai trovato quello che cerchi?</h3>
            <p class="lead text-muted mb-4">
              Il nostro team è sempre disponibile per aiutarti e rispondere
              a tutte le tue domande
            </p>
            <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
              <router-link
                :to="{ name: 'contact' }"
                class="btn btn-primary btn-lg px-4 me-sm-3"
              >
                Contattaci
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import FAQ from '@/components/home/FAQ.vue'

export default {
  name: 'FAQView',
  components: {
    FAQ
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  methods: {
    filterFAQs() {
      this.$refs.faqComponent.filterQuestions(this.searchQuery)
    }
  }
}
</script>

<style scoped>
.faq-page {
  background: #f8f9fa;
}

.faq-hero {
  background: #219ebc !important;
}

.search-box {
  border: 1px solid #8ecae6;
}

.search-box input:focus {
  border-color: #219ebc !important;
}

.btn-primary {
  background: #219ebc !important;
  border-color: #219ebc !important;
}

.btn-primary:hover {
  background: #023047 !important;
  border-color: #023047 !important;
}

.cta {
  background: rgba(142, 202, 230, 0.1) !important;
}

.bi-question-circle {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
